import Avatar from '../cards/Avatar';

// Sample avatar map (you can replace these with actual image paths)
const greyscaleImageStyle = {
    // -webkit-filter: "grayscale(100%)",
    filter: "grayscale(100%)",
};

const AvatarClump = ({ numberOfAvatars, avatarType, actualAvatar }) => {
    // Ensure the number of avatars is between 1 and 5
    const avatarCount = numberOfAvatars;

    // Define positions for avatars based on their count
    const positions = {
        5: [
            { left: '0px', bottom: '5px' },
            { left: '20px', bottom: '0px' },
            { left: '10px', bottom: '0px' },
            { left: '40px', bottom: '5px' },
            { left: '45px', bottom: '0px' }
        ],
        4: [
            { left: '5px', bottom: '0px' },
            { left: '25px', bottom: '0px' },
            { left: '15px', bottom: '5px' },
            { left: '35px', bottom: '2px' }
        ],
        3: [
            { left: '10px', bottom: '0px' },
            { left: '40px', bottom: '0px' },
            { left: '20px', bottom: '5px' }
        ],
        2: [
            { left: '15px', bottom: '0px' },
            { left: '35px', bottom: '0px' }
        ],
        1: [
            { left: '25px', bottom: '0px' }
        ],
        0: [

        ]
    };

    return (
        <div style={{ position: 'relative', width: '80px', height: '60px' }}>
            {avatarCount>0 && positions[Math.min(avatarCount,5)].map((position, index) => (
                <Avatar 
                    key={index}
                    level={avatarType}
                    style={{
                        position: 'absolute',
                        left: position.left,
                        bottom: position.bottom,
                        width: '40%',
                        ...greyscaleImageStyle
                    }}
                    alt={`Avatar ${index + 1}`}
                />
            ))}
           {avatarType === actualAvatar && (
                <Avatar 
                    level={actualAvatar}
                    className='hopper'
                    style={{ position: 'absolute', left: '5px', bottom: '0px', width: '80%' }}
                    alt='Actual Avatar' 
                />
            )}


        </div>
    );
};

export default AvatarClump;
